<template>
  <ul v-if="lastPage > 1" class="pagination">
    <li>
      <a href="#" 
         aria-label="Previous" 
         @click.prevent="pageChanged(1)">
        <span aria-hidden="true">&laquo;</span>
      </a>
    </li>
    <li
      v-for="(n, index) in paginationRange"
      :key="index"
      :class="activePage(n)">
      <a href="#" @click.prevent="pageChanged(n)">{{ n }}</a>
    </li>
    <li>
      <a
        href="#"
        aria-label="Next"
        @click.prevent="pageChanged(lastPage)">
        <span aria-hidden="true">&raquo;</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
	name: 'Pagination',
	// eslint-disable-next-line vue/require-prop-types
	props: ['labels', 'pagination',],
	computed: {
		lastPage() {
			if (this.pagination.totalPages) {
				return this.pagination.totalPages;
			} else {
				return this.pagination.totalItems % this.pagination.itemsPerPage === 0
					? this.pagination.totalItems / this.pagination.itemsPerPage
					: Math.floor(this.pagination.totalItems / this.pagination.itemsPerPage) + 1;
			}
		},
		paginationRange() {
			let start = this.pagination.currentPage - this.pagination.visiblePages / 2 <= 0
					? 1 : this.pagination.currentPage +	this.pagination.visiblePages / 2 > this.pagination.lastPage
					? this.pagination.lastPage - this.pagination.visiblePages + 1 >= 1
					? this.pagination.lastPage - this.pagination.visiblePages + 1 : 1
					: Math.ceil(this.pagination.currentPage - this.pagination.visiblePages / 2);

			let range = [];

			for (let i = 0; i < this.pagination.visiblePages && i < this.lastPage; i++) {
				range.push(start + i);
			}

			return range;
		},
	},
	methods: {
		activePage(pageNum) {
			return Number(this.pagination.currentPage) === pageNum
				? 'active'
				: '';
		},
		pageChanged(pageNum) {
			this.pagination.currentPage = pageNum;
			if (this.$route.query.filters) {
				this.$router.push({
					query: {
						page: pageNum,
						filters: this.$route.query.filters,
					},
				});
			} else if (this.$route.query.q) {
				this.$router.push({
					query: { q: this.$route.query.q, page: pageNum, },
				});
			} else {
				this.$router.push({ query: { page: pageNum, }, });
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue